import Header from './Header/Header';
import MainContent from './MainContent/MainContent';
import Footer from './Footer/Footer';

const MainPage = () => {
	const contacts = {
		contact_1: '+123456789',
		contact_2: '+987654321',
		contact_3_footer: '+7906 356 33 23'
	}

	return (
		<>
			<Header contacts={contacts} />
			<MainContent />
			<Footer contacts={contacts} />
		</>
	)

}

export default MainPage;